export default function(http) {
  return {
    queryByPage(data) {
      return http.json({
        url: `/paper/info/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        data,
      });
    },
    exportduoinfo(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/statisticsMultipathExport`,
        data,
      });
    },
    exportmaninfo(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/statisticsSatisfactionExport`,
        data,
      });
    },
    exportlineinfo(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/supervisorExport`,
        data,
      });
    },
    getlistLine(data) {
      return http.get(`/paperStatistics/basicLine/listLine?type=${data.type}`);
    },
    exportguaninfo(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/housekeeperExport`,
        data,
      });
    },
    getmanchart(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/statisticsSatisfaction`,
        data,
      });
    },
    getQuarter() {
      return http.get(`paperPrecinct/satisfaction/getQuarter`);
    },
    getguanlist(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/housekeeperList`,
        data,
      });
    },
    getmanlist(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/statisticsSatisfactionList`,
        data,
      });
    },
    getduojinglist(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/statisticsMultipathList`,
        data,
      });
    },
    gettiaolist(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/supervisorList`,
        data,
      });
    },
    gettiaochart(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/statisticsLine`,
        data,
      });
    },
    getduojingchart(data) {
      return http.json({
        url: `/paperPrecinct/satisfaction/statisticsMultipath`,
        data,
      });
    },
    queryByPageAnalyze(data) {
      return http.json({
        url: `/paper/customer/queryAnalyzeByPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        data,
      });
    },

    queryPaperTitlePage(data) {
      return http.json({
        url: `/paper/back/info/title/queryBackTitleAndOption?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        data,
      });
    },

    queryTitleAndOtion(data) {
      return http.json({
        url: `/paper/info/title/queryTitleAndOption?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        data,
      });
    },

    /**
     * 保存信息
     * @param data
     * @returns {*}
     */
    saveInfo(data) {
      return http.json({
        url: "/paper/info/save",
        data,
      });
    },

    saveAndInsertQuestionBank(data) {
      return http.json({
        url: "paper/info/v1/saveAndInsertQuestionBankLatest",
        data,
      });
    },

    saveAndInsert(data) {
      return http.json({
        url: "/paper/info/saveAndInsertQuestionBank",
        data,
      });
    },

    saveBackTitleAndOption(data) {
      return http.json({
        url: "/paper/back/info/title/saveBackTitleAndOption",
        data,
      });
    },

    /**
     * 获取详情
     * @param data
     * @return {*}
     */
    getInfo(data) {
      return http.json({
        url: `/paper/info/get?id=${data.id}`,
      });
    },

    getPaperInfo(data) {
      return http.json({
        url: `/paper/info/getPaperInfo?id=${data.id}`,
      });
    },

    /**
     * 删除
     * @param data
     * @returns {*}
     */
    removeInfo(data) {
      return http.json({
        url: `/paper/info/deleteInfoAndChildrenTitle?id=${data.id}`,
        data,
      });
    },

    deleteBank(data) {
      return http.json({
        url: `/paper/back/info/title/delete?id=${data[0].id}`,
        data,
      });
    },

    /**
     * 发布
     * @param data
     * @return {*}
     */
    publish(data) {
      return http.json({
        url: `/paper/info/publish?id=${data}`,
        data,
      });
    },

    /**
     * 取消发布
     * @param data
     * @return {*}
     */
    unPublish(data) {
      return http.json({
        url: `/paper/info/unPublish?id=${data}`,
        data,
      });
    },

    /**
     * 保存信息
     * @param data
     * @returns {*}
     */
    queryAnalyzeByPrecinctId(data) {
      return http.json({
        url: "/paper/customer/answer/queryAnalyzeByPrecinctId",
        data,
      });
    },

    queryAnalyzeByPrecinctId2(data) {
      return http.json({
        url: "/paper/customer/answer/queryAnalyzeByPrecinctId2",
        data,
      });
    },

    queryTotalProject(data) {
      return http.json({
        url: "/paper/customer/queryTotalProject",
        data,
      });
    },
    querySatisfactionList(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/statisticsSatisfactionList`,
        data,
      });
    },
    queryPaperCustomer(data) {
      return http.json({
        url: `paper/customer/queryAll?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        data,
      });
    },
    getConInfo(data) {
      return http.json({
        url: `paper/customer/comment/getConInfo?paperCusId=${data.paperCusId}`,
        data,
      });
    },
    saveConInfo(data) {
      return http.json({
        url: `paper/customer/comment/reply`,
        data,
      });
    },

    exportInfo(id) {
      return http.get(`paper/customer/answer/moveExport?infoId=${id}`);
    },


    querySatisfactionScoreList(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/satisfactionScoreList`,
        data,
      });
    },
    queryUnSatisfactionScoreList(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/uSatisfactionScoreList`,
        data,
      });
    },
    /**
     * 物业条线项不满意统计
     * @param data
     * @returns {*}
     */
    queryPropertyStatisticsList(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/propertyStatisticsList`,
        data,
      });
    },
    getActivelist(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/activitySatisfactionScoreList`,
        data,
      });
    },
    followActivityProportion(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/followActivityProportion`,
        data,
      });
    },

    queryPropertyDissatisfiedList(data) {
      return http.json({
        url: `paperPrecinct/satisfaction/propertyDissatisfiedList`,
        data,
      });
    },

    onReviewPass(params) {
      return http.json({
        url: `/paper/info/reviewPass`,
        params,
      });
    },

    onReviewReject(params) {
      return http.json({
        url: `/paper/info/reviewReject`,
        params,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/paper.js